import React, { useMemo, useState } from 'react';
import { CruiseCardProps, CruiseCardVariant } from './CruiseCard.types';
import { MapCruiseCard } from './MapCruiseCard';
import RefinedCruiseCard from './RefinedCruiseCard/RefinedCruiseCard';

function CruiseCard({ cruise, listItemIndex, variant: defaultVariant, listCount, onClick }: CruiseCardProps) {
	const [activeVariant, setActiveVariant] = useState(defaultVariant);

	const cruiseCardVariants = {
		[CruiseCardVariant.Refined]: RefinedCruiseCard,
		[CruiseCardVariant.Map]: MapCruiseCard,
	};

	const CruiseCardVariantComponent = useMemo<React.ComponentType<CruiseCardProps>>(() => {
		return cruiseCardVariants[activeVariant];
	}, [activeVariant]);

	return (
		<CruiseCardVariantComponent
			cruise={cruise}
			listCount={listCount}
			listItemIndex={listItemIndex}
			defaultVariant={defaultVariant}
			onClick={onClick}
			setActiveVariant={setActiveVariant}
		/>
	);
}

export default CruiseCard;
